import React from 'react';
import PropTypes from 'prop-types';
import Replace from '../Replace';
import ActionLink from '../../ActionLink/ActionLink';
import { getString } from '../../../helpers/stringHelpers.js';

/**
 * Replaces '$PaymentSchedule' within a string with a payment schedule link.
 */
function ReplacePaymentSchedule(props) {
  const { content, action } = props;

  const actionLink = (
    <ActionLink
      label={getString('replace', 'ARRANGEMENTS_PAYMENT_SCHEDULE_LABEL')}
      action={action}
    />
  );
  return (
    <Replace
      content={content}
      toReplace="$PaymentSchedule"
      replaceWith={actionLink}
    />
  );
}

ReplacePaymentSchedule.propTypes = {
  content: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
};

ReplacePaymentSchedule.defaultProps = {};

export default ReplacePaymentSchedule;
